<template>
  <div class="app-main-content chartConfigurationManagement">
    <div style="display:flex;justify-content: space-between;padding-top: 8px">
      <div class="filters">
        <el-form :inline="true" label-width="60px" label-position="left" @submit.native.prevent>

          <el-form-item :label="$t('BusinessIntelligence.common.tenantName')" prop="biTenantId" :show-message="false">
            <el-select
              v-model="value"
              clearable
              filterable
              :placeholder="$t('BusinessIntelligence.businessIntelligence.searchKeyword')"
            >
              <el-option
                v-for="(item, index) in tenantList"
                :key="index"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="getList">{{ $t('BusinessIntelligence.common.query') }}</el-button>
        </el-form>

      </div>
      <div class="triggers">
        <el-button type="primary" @click="copyChart = true">{{ $t('BusinessIntelligence.businessIntelligence.copyChart') }}</el-button>
        <el-button type="primary" @click="openChart = true">{{ $t('BusinessIntelligence.businessIntelligence.openBiChart') }}</el-button>
        <el-button type="primary" :disabled="selectedCount !== 1" @click="editor">{{ $t('BusinessIntelligence.common.edit') }}</el-button>
      </div>
    </div>
    <div class="section" style="flex:1;">
      <cargo-ag-grid
        style="height:100%;"
        config-module="2022082401"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>

    <!-- 复制图表 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="copyChart"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      class="copy-dialog-loading"
      :title="$t('BusinessIntelligence.businessIntelligence.copyChart')"
      :editable="true"
      width="450px"
    >
      <div class="filters">
        <el-form :inline="true" :model="copyForm" label-width="100px" @submit.native.prevent>
          <el-form-item :label="$t('BusinessIntelligence.businessIntelligence.type')">
            <el-radio-group v-model="copyForm.type">
              <el-radio :label="1">{{ $t('BusinessIntelligence.businessIntelligence.chart') }}</el-radio>
              <el-radio :label="2">{{ $t('BusinessIntelligence.businessIntelligence.dashboard') }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('BusinessIntelligence.businessIntelligence.copyChartId')">
            <el-input v-model="copyForm.chartId" type="number" class="inputWidth" :placeholder="$t('BusinessIntelligence.businessIntelligence.chartIdPlaceholder')" />
          </el-form-item>

          <el-form-item :label="$t('BusinessIntelligence.businessIntelligence.copyAll')">
            <el-checkbox v-model="copyForm.allTenant" @change="changeAll">{{ $t('BusinessIntelligence.businessIntelligence.all') }}</el-checkbox>
          </el-form-item>

          <el-form-item :label="$t('BusinessIntelligence.businessIntelligence.copyTo')">
            <cargo-advance-select
              filter-type="global"
              filterable
              multiple
              :disabled="copyForm.allTenant"
              tag-name="chineseName"
              tag-value="biTenantId"
              style="width: 300px;"
              :static-options="selectData"
              :default-multiple-value="copyForm.biTenantList"
              @parentCallBack="item=>copyForm.biTenantList=item.value"
            />
          </el-form-item>

        </el-form>
        <div style="text-align:right;margin-top:20px;">
          <el-button type="primary" size="mini" @click="copyConfirm">{{ $t('BusinessIntelligence.common.save') }}</el-button>
          <el-button size="mini" @click="copyCancel">{{ $t('BusinessIntelligence.common.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 开通BI -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="openChart"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      class="dialog-loading"
      :title="$t('BusinessIntelligence.businessIntelligence.openTenantBiChart')"
      :editable="true"
      width="550px"
    >
      <div class="filters">
        <el-form :inline="true" :model="chartForm" label-width="100px" :rules="rules" @submit.native.prevent>
          <el-form-item :label="$t('BusinessIntelligence.businessIntelligence.selectTenant')" prop="biTenantId" :show-message="false">
            <el-select v-model="chartForm.biTenantId" filterable :placeholder="$t('BusinessIntelligence.businessIntelligence.keywords')" class="inputWidth">
              <el-option
                v-for="(item, index) in tenantList"
                :key="index"
                :label="item.chineseName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('TenantMaintain.BiDomainName')">
            <el-input v-model="chartForm.biDomainName" :rows="5" type="textarea" class="inputWidth" />
          </el-form-item>
          <el-form-item :label="$t('BusinessIntelligence.businessIntelligence.note')">
            <el-input v-model="chartForm.remark" :rows="5" type="textarea" class="inputWidth" />
          </el-form-item>
        </el-form>
        <div style="text-align:right;margin-top:20px;">
          <el-button type="primary" size="mini" @click="dialogConfirm">{{ $t('BusinessIntelligence.common.save') }}</el-button>
          <el-button size="mini" @click="dialogCancel">{{ $t('BusinessIntelligence.common.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 编辑BI -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editChart"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
      class="dialog-loading"
      :title="$t('BusinessIntelligence.businessIntelligence.chartNumber')"
      :editable="true"
      width="550px"
    >
      <div class="filters">
        <div class="content">
          <div class="item">
            <span class="textLeft">{{ $t('BusinessIntelligence.businessIntelligence.tenantId') }}</span>
            <span>{{ editForm.biTenantId }}</span>
          </div>
          <div class="item">
            <span class="textLeft">{{ $t('BusinessIntelligence.common.tenantName') }}</span>
            <span>{{ mappingTenant[editForm.biTenantId] }}</span>
          </div>
          <div class="item">
            <span class="textLeft">{{ $t('BusinessIntelligence.businessIntelligence.initializeChartNum') }}</span>
            <span>{{ editForm.total }}</span>
          </div>
          <div class="item">
            <span class="textLeft">{{ $t('BusinessIntelligence.businessIntelligence.hasBeenUsedChart') }}</span>
            <span>{{ editForm.biDashboardUsedCount }}</span>
          </div>
          <div class="item">
            <span class="textLeft">{{ $t('BusinessIntelligence.businessIntelligence.openingDate') }}</span>
            <span>{{ editForm.dateCreated }}</span>
          </div>
          <div class="item alignCenter">
            <span class="textLeft">{{ $t('BusinessIntelligence.businessIntelligence.adjustNumber') }}</span>
            <div class="alignCenter">
              <el-select v-model="editForm.adjust" style="width:80px;">
                <el-option :label="$t('BusinessIntelligence.businessIntelligence.adjust1')" :value="1" />
                <el-option :label="$t('BusinessIntelligence.businessIntelligence.adjust2')" :value="2" />
              </el-select>
              <el-input v-model="editForm.num" type="number" style="width:40px;" />
              <span>{{ $t('TenantMaintain.Individual') }}</span>
            </div>
          </div>
          <div class="item alignCenter">
            <span class="textLeft">{{ $t('BusinessIntelligence.businessIntelligence.expirationTime') }}</span>
            <div class="alignCenter">
              <el-date-picker
                v-model="editForm.expiredDate"
                :picker-options="expireTimeOption"
                format="yyyy-MM-dd"
                type="date"
                :placeholder="$t('BusinessIntelligence.businessIntelligence.selectTime')"
              />
            </div>
          </div>
          <div class="item alignCenter" style="align-items: baseline;">
            <span class="textLeft">{{ $t('TenantMaintain.BiDomainName') }}</span>
            <el-input v-model="editForm.biDomainName" type="textarea" :rows="3" style="width:300px;" />
          </div>
          <div class="item alignCenter" style="align-items: baseline;">
            <span class="textLeft">{{ $t('BusinessIntelligence.businessIntelligence.note') }}</span>
            <el-input v-model="editForm.remark" type="textarea" :rows="3" style="width:300px;" />
          </div>

        </div>
        <div style="text-align:right;margin-top:20px;">
          <el-button type="primary" size="mini" @click="editSave">{{ $t('BusinessIntelligence.common.save') }}</el-button>
          <el-button size="mini" @click="editCancel">{{ $t('BusinessIntelligence.common.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getGridSelected } from '@/utils/agGrid'
import { getAllTenant } from '@/api/auth'
import { addBI, editBI, getAll, copy } from '@/api/sysManage/businessIntelligence/chartConfigurationManagement'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
export default {
  name: 'ChartConfigurationManagement',
  components: { CargoAdvanceSelect },
  data() {
    return {
      copyChart: false,
      expireTimeOption: {
        disaledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      selectData: [],
      value: '',
      selectedCount: 0,
      openChart: false,
      editChart: false,
      loading: false,
      copyForm: {
        type: 1,
        chartId: '',
        allTenant: true,
        biTenantList: []
      },
      chartForm: {
        biTenantId: '',
        biDomainName: 'bi2.cargoware.com',
        remark: '体验使用'
      },
      editForm: {
        biTenantId: '',
        tenantName: '',
        available: '',
        hasBeenUsed: '',
        adjust: 1,
        num: 5,
        dateCreated: '',
        expiredDate: '',
        biDomainName: '',
        remark: ''
      },
      classificationList: [],
      tenantList: [],
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        paginationPageSize: 500,
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          this.selectedCount = rows.length
        }
      },
      rules: {
        biTenantId: [
          {
            required: true
          }
        ]
      }
    }
  },
  computed: {
    mappingTenant() {
      const obj = {}
      this.tenantList.map((item) => {
        obj[item.code] = item.chineseName
      })
      return obj
    },
    columnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('BusinessIntelligence.businessIntelligence.tenantId'),
          field: 'biTenantId',
          width: 100
        },
        {
          headerName: this.$t('BusinessIntelligence.common.tenantName'),
          field: 'tenantName',
          width: 150
        },
        {
          headerName: this.$t('BusinessIntelligence.businessIntelligence.available'),
          field: 'total',
          width: 150
        },
        {
          headerName: this.$t('BusinessIntelligence.businessIntelligence.hasBeenUsed'),
          field: 'biDashboardUsedCount',
          width: 150
        },
        {
          headerName: this.$t('TenantMaintain.BiDomainName'),
          field: 'biDomainName',
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('BusinessIntelligence.businessIntelligence.noteInformation'),
          field: 'remark',
          width: 150
        }
      ]
    }
  },
  async created() {
    const res = await getAllTenant()
    if (res.ok) {
      for (const tenant of res.data) {
        const chineseName = `[${tenant.id}]${tenant.name}`
        const englishName = tenant.englishName
        this.tenantList.push({ code: Number(tenant.id), chineseName: chineseName, englishName: englishName })
      }
    }
    await this.getList()
  },
  methods: {
    // 复制图表或仪表盘保存
    async copyConfirm() {
      if (!this.copyForm.chartId) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligence.copyIdRemind'))
        return
      }
      if (!this.copyForm.allTenant && this.copyForm.biTenantList.length === 0) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligence.copyAllRemind'))
        return
      }
      this.$confirm(this.$t('TenantMaintain.AreYouWantToCopy'), this.$t('TenantMaintain.Hint'), {
        confirmButtonText: this.$t('TenantMaintain.Confirm'),
        cancelButtonText: this.$t('TenantMaintain.Cancel'),
        type: 'warning'
      }).then(() => {
        const data = {
          type: this.copyForm.type,
          chartId: this.copyForm.chartId,
          allTenant: this.copyForm.allTenant
        }
        if (!this.copyForm.allTenant) {
          data.tenants = this.copyForm.biTenantList
        }
        this.loading = getLoading('copy-dialog-loading')
        copy(data).then((res) => {
          if (res.ok) {
            this.getList()
            this.copyCancel()
            this.$message.success(this.$t('BusinessIntelligence.businessIntelligence.copySuccess'))
          }
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    // 勾选复制到所有租户时，清空选择的部分租户列表
    changeAll(value) {
      value ? this.copyForm.biTenantList = [] : ''
    },
    // 复制图表或仪表盘取消
    copyCancel() {
      this.copyChart = false
      this.copyForm = {
        type: 1,
        chartId: '',
        allTenant: false,
        biTenantList: []
      }
    },
    // 获取列表数据
    async getList() {
      const data = {}
      this.value ? data.biTenantId = this.value : ''
      const res = await getAll(data)
      if (res.ok) {
        if (res.data.length > 0) {
          res.data.forEach((item) => {
            item.tenantName = this.mappingTenant[item.biTenantId]
            item.chineseName = this.mappingTenant[item.biTenantId]
            item.total = item.biDashboardFreeLimit + item.biDashboardPayLimit
          })
        }
        this.rowData = res.data
        this.selectData = JSON.parse(JSON.stringify(res.data))
      } else {
        this.selectData = []
        this.rowData = []
      }
      this.selectedCount = 0
    },
    // 开通BI弹窗保存
    async dialogConfirm() {
      if (!this.chartForm.biTenantId) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligence.saveWarning'))
        return
      }
      if (!this.chartForm.biDomainName) {
        this.$message.warning(this.$t('TenantMaintain.FillBiDomainName'))
        return
      }
      const data = {
        biTenantId: Number(this.chartForm.biTenantId),
        biDomainName: this.chartForm.biDomainName
      }
      this.chartForm.remark ? data.remark = this.chartForm.remark : ''
      this.loading = getLoading('dialog-loading')
      const res = await addBI(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.value = ''
        this.getList()
        this.dialogCancel()
        this.$message.success(this.$t('BusinessIntelligence.businessIntelligence.saveSuccess'))
      }
    },
    // 打开编辑弹窗
    async editor() {
      this.editChart = true
      const data = await getGridSelected(this.gridOptions)[0]
      this.editForm = {
        ...data
      }
      this.$set(this.editForm, 'adjust', 1)
      this.$set(this.editForm, 'num', 5)
      this.$set(this.editForm, 'expiredDate', data.expiredDate)
      console.log('data', data)
    },
    // 编辑保存
    async editSave() {
      if (!this.editForm.num) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligence.editWarning'))
        return
      }
      if (this.editForm.num < 0) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligence.adjustQuantity1'))
        return
      }
      if (this.editForm.adjust === 2 && this.editForm.num > this.editForm.total) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligence.adjustQuantity2'))
        return
      }
      if (!this.editForm.expiredDate) {
        this.$message.warning(this.$t('BusinessIntelligence.businessIntelligence.editWarningTime'))
        return
      }
      if (!this.editForm.biDomainName) {
        this.$message.warning(this.$t('TenantMaintain.FillBiDomainName'))
        return
      }
      const newEditForm = JSON.parse(JSON.stringify(this.editForm))
      const data = {
        biDashboardFreeLimit: newEditForm.biDashboardFreeLimit,
        biTenantId: newEditForm.biTenantId,
        biDashboardPayLimit: '',
        remark: newEditForm.remark,
        expiredDateTimestamp: new Date(newEditForm.expiredDate).valueOf(),
        biDomainName: newEditForm.biDomainName
      }
      if (newEditForm.adjust === 1) {
        data.biDashboardPayLimit = newEditForm.biDashboardPayLimit + Number(newEditForm.num)
      } else {
        data.biDashboardPayLimit = newEditForm.biDashboardPayLimit - newEditForm.num
      }
      this.loading = getLoading('dialog-loading')
      const res = await editBI(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.editCancel()
        this.value = ''
        this.getList()
        this.$message.success(this.$t('BusinessIntelligence.businessIntelligence.editSuccess'))
      }
    },
    // 编辑取消
    editCancel() {
      this.editChart = false
      this.editForm = {
        biTenantId: '',
        tenantName: '',
        available: '',
        hasBeenUsed: '',
        adjust: 1,
        num: 5,
        dateCreated: '',
        expiredDate: '',
        biDomainName: ''
      }
    },
    // 弹窗取消
    dialogCancel() {
      this.openChart = false
      this.chartForm = {
        biTenantId: '',
        biDomainName: '',
        remark: ''
      }
    }
  }
}
</script>
<style lang="scss">
.chartConfigurationManagement{
  display: flex;
  flex-direction: column;
  flex:1;
  padding:0 20px;
  box-sizing: border-box;
  .inputWidth{
    width:300px !important;
  }
  .content{
    display:flex;
    flex-direction: column;
    margin-left: 50px;
    .item{
      margin-top:10px;
      .textLeft{
        display:inline-block;
        width:80px;
        text-align:right;
        margin-right:10px;
      }
    }
    .alignCenter{
      display: flex;
      align-items: center;
    }
  }
}
</style>
